import React, { useEffect, useState } from "react";
import axios from "../../../Utils/Axios";
import { useHistory } from "react-router-dom";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { useAlert } from "react-alert";
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { Link } from "react-router-dom";
import { ErrorHandler } from "../../../ui/ErrorHandler";
import "./BrandCategory.css";
import TextEditor from "../../../ui/TextEditor";
import Faq from "../../FAQ/Faq";
import Tag from "../../Tags/Tag";
import PageSection from "../../PageSection/PageSection";
import SelectSearch from 'react-select-search';
function EditBrandCategory(props) {
    const alert = useAlert();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState([]);
    const [brandCategory, setBrandCategory] = useState({});
    const [seo, setSeo] = useState({});
    const [brandCategoryId, setBrandCategoryId] = useState(
        props.match && props.match.params && props.match.params.id
            ? props.match.params.id
            : ""
    );
    useEffect(() => {
        getBrandCategoryDetails();
        getBrands();
        getCategories();
    }, [props.match.params.id]);
    const getBrandCategoryDetails = () => {
        axios(`admin/brand_categories/${props.match.params.id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    setBrandCategory(response.data.data.brand_category);
                    setSeo(response.data.data.seo[0] ?? {});
                } else {
                    setLoading(false);
                    ErrorHandler(alert, response.status, response.data.message)
                }
            })
            .catch(({ response }) => {
                setLoading(false);
                ErrorHandler(alert, response.status, response.data.message)
            });
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        let formdata = new FormData();
        formdata.append("brand_id", brandCategory.brand_id);
        formdata.append("category_id", brandCategory.category_id);
        formdata.append("title", brandCategory.title);
        formdata.append("title_ar", brandCategory.title_ar);
        formdata.append("description", brandCategory.description);
        formdata.append("description_ar", brandCategory.description_ar);
        formdata.append("short_description", brandCategory.short_description);
        formdata.append("slug", brandCategory.slug);
        formdata.append("short_description_ar", brandCategory.short_description_ar);
        formdata.append("meta_title", seo.meta_title);
        formdata.append("meta_description", seo.meta_description);
        formdata.append("meta_keyword", seo.meta_keyword);
        formdata.append("store_id", 1);
        formdata.append("lang_id", 1);
        formdata.append("id", brandCategoryId);
        axios("admin/brand_category_update", {
            method: "POST",
            data: formdata,
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
            },
        })
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    setLoading(false);
                    ErrorHandler(alert, response.status, response.data.message)
                    history.push({
                        pathname: "/brand-categories",
                        state: { data: true },
                    });
                } else {
                    setLoading(false);
                    ErrorHandler(alert, response.status, response.data.message)
                }
            })
            .catch(({ response }) => {
                setLoading(false);
                ErrorHandler(alert, response.status, response.data.message)
            });
    };
    const getBrands = () => {
        axios("admin/brand_list", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    setBrands(response.data.data);
                } else {
                    setLoading(false);
                }
            })
            .catch(({ response }) => {
                setLoading(false);
            });
    };

    const getCategories = () => {
        axios("admin/category_list", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Bearer " + JSON.parse(localStorage.getItem("data")),
            },
        })
            .then((response) => {
                if (response.status === 200) {
                    setCategories(response.data.data);
                } else {
                    setLoading(false);
                }
            })
            .catch(({ response }) => {
                setLoading(false);
            });
    };
    return (
        <div>
            <div class="container-fluid">
                <div role="presentation">
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link underline="hover" color="inherit" to="/">
                            Home
                        </Link>
                        <Link
                            underline="hover"
                            color="inherit"
                            to="/brand-categories"
                        >
                            Brand Categories
                        </Link>
                        <Link
                            underline="hover"
                            color="text.primary"
                            to="#"
                            aria-current="page"
                        >
                            Edit Brand Categories
                        </Link>
                    </Breadcrumbs>
                    <hr></hr>
                </div>
                <div class="container-fluid  mt-5">

                    <div className="row">
                        <div className="col-md-8">
                            {Object.keys(brandCategory).length != 0 && (
                                <form method="POST" className="category-form">
                                    <h3 className="edit-title">Edit Brand Category <i class="fi fi-rr-file-edit"></i></h3>
                                    <hr></hr>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <SelectSearch options={categories} onChange={(e) => setBrandCategory({
                                                ...brandCategory,
                                                category_id: e,
                                            })} value={brandCategory.category_id} search placeholder="Choose Category" />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SelectSearch options={brands} onChange={(e) => setBrandCategory({
                                                ...brandCategory,
                                                brand_id: e,
                                            })} value={brandCategory.brand_id} search placeholder="Choose Brand" />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField id="outlined-basic" fullWidth label="Title" variant="outlined" onChange={(e) => setBrandCategory({
                                                ...brandCategory,
                                                title: e.target.value,
                                            })} value={brandCategory.title} name="title" />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField id="outlined-basic" fullWidth label="Title Arabic" variant="outlined" onChange={(e) => setBrandCategory({
                                                ...brandCategory,
                                                title_ar: e.target.value,
                                            })} value={brandCategory.title_ar} name="title_ar" />
                                        </Grid>
                                        <Grid item xs={6}>

                                            <label className="label-description">
                                                Description<br></br>
                                                <TextEditor defaultValue={brandCategory.description} onChange={(e) => setBrandCategory({
                                                    ...brandCategory,
                                                    description: e,
                                                })} />
                                            </label>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <label className="label-description">
                                                Description Arabic<br></br>
                                                <TextEditor defaultValue={brandCategory.description_ar} onChange={(e) => setBrandCategory({
                                                    ...brandCategory,
                                                    description_ar: e,
                                                })} />
                                            </label>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <label className="label-description">
                                                Short Description<br></br>
                                                <textarea className="description" rows={4} cols={40} onChange={(e) => setBrandCategory({
                                                    ...brandCategory,
                                                    short_description: e.target.value,
                                                })} value={brandCategory.short_description} name="short_description" />
                                            </label>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <label className="label-description">
                                                Short Description Arabic<br></br>
                                                <textarea className="description" rows={4} cols={40} onChange={(e) => setBrandCategory({
                                                    ...brandCategory,
                                                    short_description_ar: e.target.value,
                                                })} value={brandCategory.short_description_ar} name="short_description_ar" />
                                            </label>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <button type="button" onClick={handleSubmit} className="btn btn-primary  "><i class="fi fi-rr-refresh"></i> Update</button>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}

                        </div>
                        <div className="col-md-4">
                            {Object.keys(seo).length != 0 && (
                                <form method="POST" className="category-form">
                                    <h3 className="edit-title"> SEO Contents  <i class="fi fi-rr-file-edit"></i> </h3>
                                    <hr></hr>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField id="outlined-basic" fullWidth label="Seo url" variant="outlined" onChange={(e) => setBrandCategory({
                                                ...brandCategory,
                                                slug: e.target.value,
                                            })} value={brandCategory.slug} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField id="outlined-basic" fullWidth label="Meta Title" variant="outlined" onChange={(e) => setSeo({
                                                ...seo,
                                                meta_title: e.target.value,
                                            })} value={seo.meta_title} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className="label-description">
                                                Meta Description<br></br>
                                                <textarea className="description" rows={4} cols={40} onChange={(e) => setSeo({
                                                    ...seo,
                                                    meta_description: e.target.value,
                                                })} value={seo.meta_description} />
                                            </label>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField id="outlined-basic" fullWidth label="Meta Keyword" variant="outlined" onChange={(e) => setSeo({
                                                ...seo,
                                                meta_keyword: e.target.value,
                                            })} value={seo.meta_keyword} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            {/* <button type="button" onClick={handleSubmit} className="btn btn-primary  "><i class="fi fi-rr-refresh"></i> Update</button> */}
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </div>
                    </div>

                </div>
            </div>
            <div class="container-fluid  mt-5">
                <Faq page={'brandCategory'} pageId={brandCategoryId}></Faq>
            </div>
            <div class="container-fluid  mt-5">
                <Tag page={'brandCategory'} pageId={brandCategoryId}></Tag>
            </div>
            <div class="container-fluid  mt-5">
                <PageSection page={'brandCategory'} pageId={brandCategoryId}></PageSection>
            </div>
        </div>
    );
}
export default EditBrandCategory;